export enum CaseStatusEnum {
  NEW = 'New',
  OPEN = 'Open',
  UPDATE = 'Update',
  PENDING = 'Pending',
  VERIFY = 'Verify',
  CLOSED_RESOLVED = 'Closed_Resolved',
  CLOSED_NOT_RESOLVED = 'Closed_NotResolved',
}

export enum NextActionStatusEmum {
  InitialResponseRequired = 'InitialResponseRequired',
  PendingCustomer = 'PendingCustomer',
  PendingInternalCaseContact = 'PendingInternalCaseContact',
  Wip = 'Wip',
  Wip_Apps = 'Wip_Apps',
  Wip_Stc = 'Wip_Stc',
  Wip_L4 = 'Wip_L4',
  PilotDeployment = 'PilotDeployment',
  SolutionDeployment = 'SolutionDeployment',
  Closed = 'Closed'
}
